import React, { useEffect, useState } from 'react';

import analytics from '~chatbot/analytics';
import starIcon from '~chatbot/assets/stars-icon.svg';
import { useChatbotContext } from '~chatbot/context/ChatbotContext';
import styles from './SuggestedOptions.module.scss';

function SuggestedOptions() {
  const { setPrompt, handleSubmit, config } = useChatbotContext();
  const { autoSuggestOptions } = config;

  const [promptUpdatedFromOption, setPromptUpdatedFromOption] = useState(false);
  const handleTracking = (properties, ctaType = 'cta_click', source) => {
    analytics.click(
      ctaType,
      source,
      properties,
    );
  };

  const handleOptionClick = (optionText, index) => {
    handleTracking({
      click_type: 'button_click',
      click_text: '',
      element: `Suggested Prompt ${index + 1}`,
      section: 'Chatbot (active state)',
    });
    setPrompt(optionText);
    setPromptUpdatedFromOption(true);
  };

  useEffect(() => {
    if (promptUpdatedFromOption) {
      handleSubmit();
      setPromptUpdatedFromOption(false);
    }
  }, [promptUpdatedFromOption, handleSubmit]);


  return (
    <div className={styles.wrapper}>
      <div>
        Suggested Questions &nbsp;
        <span>
          <img src={starIcon} alt="stars" />
        </span>
      </div>

      {autoSuggestOptions.map((optionText, index) => (
        <div
          key={index}
          className={styles.options}
          role="button"
          tabIndex={index}
          onClick={() => handleOptionClick(optionText, index)}
        >
          {optionText}
        </div>
      ))}
    </div>
  );
}

export default SuggestedOptions;
